import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PortalLayout from "./components/PortalLayout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";

/** A signed-in user hitting /login is sent straight to their dashboard. */
const LoginRoute = () => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/login" element={<LoginRoute />} />

    <Route
      element={
        <ProtectedRoute>
          <PortalLayout />
        </ProtectedRoute>
      }
    >
      {/* Everything — stats, the claims table, submitting, and viewing a
          claim's detail drawer — lives on this one page now. /claims/:id
          still deep-links straight into the detail drawer. */}
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/claims" element={<Navigate to="/dashboard" replace />} />
      <Route path="/claims/:claimId" element={<Dashboard />} />
    </Route>

    <Route path="*" element={<Navigate to="/dashboard" replace />} />
  </Routes>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
